import * as R from 'ramda';

export default function GRReportTypeController(
  $q,
  $rootScope,
  $scope,
  $filter,
  loaderService,
  ssDialogService,
  reportsSharedModelService,
  bulkArchiveGeneratedReportInstancesDialog,
) {
  const vm = this;

  vm.isExpanded = false;

  vm.hasData = false;

  vm.filter = {
    reportOwner: "-1"
  };

  vm.reportInstances = [];
  vm.allReportInstances = [];
  
  vm.numberOfInstances = vm.reportType.numberOfInstances;
  vm.lastGeneratedDate = vm.reportType.lastGeneratedDate;

  vm.showBulkArchive = (vm.numberOfInstances > 0);

  vm.handleExpandReportType = handleExpandReportType;
  vm.handleBulkArchive = _handleBulkArchive;


  /** ********************************************
   * Event Handlers
   */

  $scope.$on(`reports.generatedReports.reportType.reportInstanceUnpublished`, (event, reportInstance) => { 
    const _uniqueId = reportInstance.familyId + '-' + reportInstance.reportId;  
    if (_uniqueId == vm.reportType.uniqueId) {
      _handleRemoveReportInstance(reportInstance);
    }
  });

  $scope.$on(`reports.generatedReports.reportType.reportInstanceArchived`, (event, reportInstance) => { 
    const _uniqueId = reportInstance.familyId + '-' + reportInstance.reportId;  
    if (_uniqueId == vm.reportType.uniqueId) {
      _handleRemoveReportInstance(reportInstance);
    }
  });

  $scope.$on(`reports.generatedReports.reportType.reportInstancesArchived`, (event, opt) => { 
    if (opt.uniqueId == vm.reportType.uniqueId) {
      _loadReportInstances();
    }
  });

  $scope.$on(`reports.generatedReports.updateReportInstancesReportOwner`, (event, opt) => { 
    vm.filter.reportOwner = opt.reportOwner;
    vm.reportInstances = _filterByReportOwner();

    if (vm.hasData) {
      _updateReportInstanceCounts();
    }
  });

  function handleExpandReportType() {
    if (vm.isExpanded) {
      vm.isExpanded = false;
      return;
    }

    loaderService.showViewLoader = true;
    _loadReportInstances().then(() => {
      loaderService.showViewLoader = false;
      vm.isExpanded = true;
    });
  }

  function _handleBulkArchive($event) {
    if (!vm.hasData) {
      loaderService.showViewLoader = true;
      _loadReportInstances().then(() => {
          loaderService.showViewLoader = false;
          showBulkArchiveReportInstancesDialog($event);
        });
    } else {
      showBulkArchiveReportInstancesDialog($event);
    }
  }
  
  function showBulkArchiveReportInstancesDialog($event) {
     ssDialogService.dialogs.reports.bulkArchiveGeneratedReportInstancesDialog = ssDialogService.alert(
      bulkArchiveGeneratedReportInstancesDialog.getOptions($event, {
        reportType: vm.reportType,
        reportInstances: vm.reportInstances,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.reports.bulkArchiveGeneratedReportInstancesDialog);
  }

  /** ********************************************
   * Private Functions
   */

  function _loadReportInstances() {
    vm.hasData = false;
    return reportsSharedModelService.getCustomerReportInstances(vm.reportType.uniqueId, true)
      .then((reportInstances) => {
        vm.allReportInstances = [...reportInstances];
        vm.reportInstances = _filterByReportOwner();
        _updateReportInstanceCounts();
        if (vm.allReportInstances.length > 0) {
          vm.hasData = true;
        } else {
          // This reportType just lost its last reportInstance, so it should be removed
          vm.allReportInstances = [];
          $rootScope.$broadcast('reports.generatedReports.reportTypeEmpty', vm.reportType);
          return;
        }  
      });
  }

  function _filterByReportOwner() {
    let _filteredReportInstances = [];

    if ((vm.allReportInstances === null) || (vm.allReportInstances.length === 0)) {
      _filteredReportInstances = vm.allReportInstances;
    } else {
      if (vm.filter.reportOwner !== "-1") {
        const _fris = [];
        R.forEach((reportInstance) => {          
          let _found = false;
              
          if (reportInstance.createdBy === vm.filter.reportOwner ) {
            _found = true;
          };

          if (_found) {
            _fris.push(reportInstance);
          }
        }, vm.allReportInstances);

        _filteredReportInstances = _fris;
      } else {
        _filteredReportInstances = vm.allReportInstances;
      }
    }
    
    return _filteredReportInstances;
  }

  function _handleRemoveReportInstance(reportInstance) {
    if (!reportInstance) {
      return;
    } 

    if (vm.allReportInstances.length <= 1) {
      // This reportType just lost its last reportInstance, so it should be removed
      vm.allReportInstances = [];
      $rootScope.$broadcast('reports.generatedReports.reportTypeEmpty', vm.reportType);
      vm.isExpanded = false;
      vm.hasData = false;
      return;
    }

    _remove(vm.allReportInstances);
    _remove(vm.reportInstances);

    function _remove(collection) {
      const pos = collection.findIndex(item => item.reportInstanceId === reportInstance.reportInstanceId);
      if (pos === -1) {
        return; // Can't find the item
      }
      collection.splice(pos, 1);
    }

    // Update summary info
    vm.numberOfInstances = vm.reportInstances.length;
    vm.reportType.numberOfInstances = vm.reportInstances.length;
    vm.lastGeneratedDate = _getMaxDate(vm.reportInstances);
  }

  function _getMaxDate(reportInstances) {
    let maxDate = new Date();
    if (reportInstances.length > 0) {
      maxDate = reportInstances[0].createDate;
      let maxDateObj = new Date(reportInstances[0].createDate);
      reportInstances.forEach((instance) => {
        if (new Date(instance.createDate) > maxDateObj) {
          maxDate = instance.createDate;
          maxDateObj = new Date(instance.createDate);
        }
      });
    }
    return maxDate;
  }

  function _updateReportInstanceCounts() {
    vm.numberOfInstances = vm.reportInstances.length;
    vm.reportType.numberOfInstances = vm.reportInstances.length;
  }
}

GRReportTypeController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$filter',
  'loaderService',
  'ssDialogService',
  'reportsSharedModelService',
  'bulkArchiveGeneratedReportInstancesDialog',
];
